<template>
  <dash-modal
    :name="name"
    :header="header"
  >
    <div slot="contents">
      <slot name="contents" />
    </div>
    <div slot="actions" class="actions">
      <button
        class="button"
        @click="confirmed(false)"
      >
        {{ cancelLabel }}
      </button>
      <button
        class="button primary"
        :disabled="disabled"
        @click="confirmed(true)"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </dash-modal>
</template>
<script>
import DashModal from '@/components/common/DashModal';

export default {
  name: 'DashInputModal',
  components: {
    DashModal,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: 'Confirm',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
  },
  data() {
    return {
      promisedResolution: null,
    };
  },
  methods: {
    confirmed(value) {
      this.$modal.hide(this.name);
      this.promisedResolution(value);
      this.promisedResolution = null;
    },
    confirm() {
      return new Promise((resolve) => {
        this.$modal.show(this.name);
        this.promisedResolution = resolve;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/buttons";

.actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.button {
  @include button(#1E1D1D, #333333, $white);
  height: 50px;
  width: 200px;
  &.primary {
    @include button($orange, $orange, $white);
    height: 50px;
    width: 200px;
  }
}
</style>
